<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="title"
        width="400px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
    >
        <p>{{ desc }}</p>

        <el-radio-group v-model="verifyType" class="verify-method" v-if="verifyTypeList.length>0">
            <el-radio :label="item.value" v-for="item in verifyTypeList" :key="item.value">{{item.title}}</el-radio>
        </el-radio-group>

        <el-input
            style="margin-top: 20px;"
            v-model="verifyCode"
            :placeholder="$t('input.placeholder.verify_code')"
        >
            <div
                v-if="sendStatus === 1"
                slot="append"
                style="cursor: pointer"
            >
                <div
                    style="width: 100%; height: 100%"
                    @click="sendCode()"
                >
                    {{ $t("button.verify_code_send") }}
                </div>
            </div>
            <div v-if="sendStatus === 2" slot="append">
                <i class="el-icon-loading" />
            </div>
            <div v-if="sendStatus === 3" slot="append">
                {{ sendText }}
            </div>
        </el-input>

        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">{{ $t('qu-xiao') }}</el-button>
            <el-button type="primary" @click="confirm">{{ $t('que-ren') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { sendCode } from '@/api/user'
import { IsMail, IsTel } from '@/utils/verify'
import { CaptchaCode } from '@/utils/captcha'
export default {
    name: 'TwoFactor',
    data () {
        return {
            dialogVisible: false,
            title: '',
            desc: '',
            verifyType: '',
            verifyCode: '',
            cooldown: 0,
            verifyTypeList: [],
            sendText: this.$t('button.verify_code_send'),
            sendStatus: 1
        }
    },
    methods: {
        showDialog (params) {
            const { title = '', desc = '', verifyTypeList = [], sendProduct = '', telNum = '', mail = '', verifyType = '' } = params || {}
            this.title = title
            this.desc = desc
            this.verifyType = verifyType
            this.verifyTypeList = verifyTypeList
            this.sendProduct = sendProduct
            this.telNum = telNum
            this.mail = mail
            this.dialogVisible = true
        },
        hideDialog () {
            this.dialogVisible = false
            this.verifyCode = ''
        },
        confirm () {
            if (!this.verifyCode) {
                return this.$message.warning(this.$t('qing-shu-ru-yan-zheng-ma'))
            }

            this.$emit('verify-success', {
                verify_type: this.verifyType,
                verify_code: this.verifyCode
            })

            this.hideDialog()
        },
        cancel () {
            this.hideDialog()
            this.$emit('verify-cancel')
        },
        // 倒计时
        lastTime () {
            let time = 60
            const lastInterval = setInterval(() => {
                this.sendStatus = 3
                if (time <= 0) {
                    clearInterval(lastInterval)
                    this.sendStatus = 1
                    this.sendText = this.$t('button.verify_code_send')
                    return
                }
                time--
                this.sendText = `${time}s`
            }, 1000)
        },
        // 发送验证码
        async sendCode (data) {
            this.sendStatus = 2
            if (this.verifyType === 'tel' && !IsTel(this.telNum)) {
                this.sendStatus = 1
                this.$message.error(this.$t('shou-ji-ge-shi-bu-zheng-que'))
                return
            }
            if (this.verifyType === 'mail' && !IsMail(this.mail)) {
                this.sendStatus = 1
                this.$message.error(this.$t('input.verify.mail_format'))
                return
            }

            // 验证码
            let captchaData = {}
            try {
                captchaData = await CaptchaCode()
            } catch (err) {
                if (err === 'cancel') {
                    this.sendStatus = 1
                    return
                }
                this.sendStatus = 1
                console.error('CaptchaCode Err:' + err)
                this.$message.error(err.msg || err || this.$t('message.verify_code_fail'))
                throw err
            }

            const { captcha_id, captcha_value } = captchaData || {}
            try {
                await sendCode({
                    captcha_id,
                    captcha_value,
                    tel_num: this.verifyType === 'tel' ? this.telNum : '',
                    mail: this.verifyType === 'mail' ? this.mail : '',
                    product: this.sendProduct
                })
                this.lastTime(data)
            } catch (err) {
                this.sendStatus = 1
                console.error('sendCode err', err)
                this.$message.error(err.msg || err || this.$t('message.send_code_fail'))
            }
        }

    }
}
</script>

  <style scoped>
  .verify-method {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  </style>
